import React, { createRef, useState, useEffect } from 'react';
//providers
import { useTranslation } from 'react-i18next';
//theme
import { Box, Heading, Flex, Container, Button} from '@chakra-ui/react';
//redux
import { getCompanyLoading, getAuthExpiring, getCompanyErrors } from '../redux/selectors';
import { useDispatch, useSelector } from "react-redux";
import { refreshAuth } from '../redux/authUserSlice';
import { uploadSigningRightsFile } from '../redux/companiesSlice';
import { ADMIN, validateInput } from '../redux/helpers';
//compontents
import FormElement from './FormElement';
import BreadcrumbNav from './BreadcrumbNav';
import MessageBox from './MessageBox';

const ManualActivation = () => {
  const { t, ready } = useTranslation();
  const dispatch = useDispatch();
  const authExpiring = useSelector(getAuthExpiring());
  const [file, setFile] = useState(null);
  const [state, setState] = useState(0);
  const loading = useSelector(getCompanyLoading);
  const companyErrors = useSelector(getCompanyErrors);

  const handleFileChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile && newFile.type !== "application/pdf") {
      updateFormData({
        ...formData,
        errors: {
            ...formData.errors,
            "file": t("form.file-not-pdf")
        }
      });
      setFile(null);
      return;
    }
    setFile(newFile);

    if (newFile) {
      updateFormData({
        ...formData,
        errors: {
            ...formData.errors,
            "file": ""
        }
      });
    }
  };

  useEffect(() => {
    if (loading) {
      if (state === 1) {
        setState(2);
      }
    }
    else if (state !== 0) {
      if (state === 2 && companyErrors) {
          setState(0);
      }
      else {
        setState(3);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    if (authExpiring) {
      dispatch(refreshAuth());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authExpiring]);

      const initialForm = Object.freeze({
          businessid:  "",
          role: ADMIN,
          person: {
              socialSecurityNumber: "",
              identifierCountryCode: "FI",
              firstNames: "",
              lastName: ""
          },
          overwrite: false,
          phoneNumber: "",
          email: "",
          errors: {
            businessid: "",
            firstNames: "",
            lastName: "",
            socialSecurityNumber: "",
            identifierCountryCode: "",
            phoneNumber: "",
            email: "",
            file: ""
          }
      });
  
  
      const options = {
          identifierCountryCode: ["FI", "SV", "NO", "EE"],
      }
  
      const SSN = createRef();
      const CC = createRef();
  
      const [formData, updateFormData] = useState(initialForm);

    const getErrors = (properties) => {
        let allErrors = {};
        const personFields = Object.keys(formData.person);
        const countryCode = formData.person.identifierCountryCode;
        const checkArray = properties ? Object.keys(properties) : Object.keys(formData.errors);

        checkArray.forEach((property) => {
            if (property === "file") {
              if (!file) {
                allErrors = { ...allErrors, "file": t("form.file-missing") };
              }
              else if (file.type !== "application/pdf") {
                allErrors = { ...allErrors, "file": t("form.file-not-pdf") };
              }
              else {
                allErrors = { ...allErrors, "file": "" };
              }
              return;
            }

            const prefix = personFields.includes(property) ? "person" : "";
            const propertyValue = properties ? properties[property] : null;
            const formValue = prefix ? formData[prefix][property] : formData[property];
            const value = propertyValue !== null ? propertyValue : formValue;
            const error = validateInput(property, value, countryCode, options[property]) ? "" : t("userform.invalid-input", { inputname: t("form." + property).toLowerCase() });

            allErrors = { ...allErrors, [property]: error };
        });

        return allErrors;
    }


      const handleInputChange = (e) => {
        let property = e.target.name;
        let value = e.target.value;
        if (property === "overwrite") {
          value = e.target.checked;
        }
        const prefix = Object.keys(formData.person).includes(property) ? "person" : "";
        let key = prefix ? prefix : property;
        let update = prefix ? { ...formData[prefix], [property]: value } : value;

        let allErrors = getErrors({ [property]: value });

        //update state
        updateFormData({
            ...formData,
            [key]: update,
            errors: {
                ...formData.errors,
                ...allErrors,
            }
        });
    }

          const handleSSNChange = (e) => {
              let valueSSN = SSN.current.value;
              let valueCC = CC.current.value;
      
              const validCountryCode = validateInput("identifierCountryCode", valueCC, valueCC, options.identifierCountryCode);
              const validSocialSecurityNumber = validateInput("socialSecurityNumber", valueSSN, valueCC, options.identifierCountryCode);
      
              const errors = {
                  socialSecurityNumber: validSocialSecurityNumber ? "" : t("userform.invalid-input", { inputname: t("form.socialSecurityNumber").toLowerCase() }),
                  identifierCountryCode: validCountryCode ? "" : t("userform.invalid-input", { inputname: t("form.countryCode").toLowerCase() })
              }
      
              updateFormData({
                  ...formData,
                  person: {
                      ...formData.person,
                      identifierCountryCode: valueCC,
                      socialSecurityNumber: valueSSN,
                  },
                  errors: {
                      ...formData.errors,
                      ...errors,
                  }
              });
      
          }
          const formErrors = (Object.values(formData.errors).find(value => value !== "")) ? true : false;

  const breadcrumbLinks = [
    { url: "/", text: "breadcrumb.Company-selection" },
    { url: `/manualactivation`, text: "breadcrumb.Manualactivation" }
  ]


      const submitForm = () => {
          let formHasErrors = false;
          const allErrors = getErrors();
          if (Object.values(allErrors).find(value => value !== "")) {
              formHasErrors = true;
              updateFormData({
                  ...formData,
                  errors: {
                      ...formData.errors,
                      ...allErrors
                  }
              });
          }
  
          if (!formErrors && !formHasErrors) {
            dispatch(uploadSigningRightsFile({file: file, form: formData}));
            setState(1);
          }
      }

  return (
    <>
      { ready &&
      <>
        <Container as="main" maxW="55em" pb="9%">
          <BreadcrumbNav links={breadcrumbLinks} />
          <Heading mt="10%" as="h1" textStyle="h1" fontWeight={["400"]} mb="3">
            {t("manualactivation.title")}
          </Heading>
           <Box autoCompletion="off">
            <Flex flexDirection={["column", "row"]}>
              <FormElement name="overwrite" type="checkbox" state={formData} handleInputChange={handleInputChange}/>
            </Flex>
            <Flex flexDirection={["column", "row"]}>
              <FormElement name="businessid" state={formData} handleInputChange={handleInputChange}/>
              <Flex flexDirection={["column", "row"]}>
                <input type="file" accept="application/pdf" onChange={handleFileChange} />
                <Box textStyle="errortext"> {formData.errors["file"]} </Box>
              </Flex>
            </Flex>
            <Flex flexDirection={["column", "row"]}>
              <FormElement name="firstNames" prefix="person" state={formData} handleInputChange={handleInputChange}/>
              <FormElement name="lastName" prefix="person" state={formData} handleInputChange={handleInputChange}/>
            </Flex>
            <Flex flexDirection={["column", "row"]}>
              <FormElement name="socialSecurityNumber" prefix="person" state={formData} handleInputChange={handleSSNChange} ref={SSN}/>
              <FormElement name="identifierCountryCode" type="select" options={options.identifierCountryCode} prefix="person" state={formData} handleInputChange={handleSSNChange} ref={CC}/>
            </Flex>
            <Heading as="h2" textStyle="h3" mt="6" mb="3">{t("userform.Contacts")}</Heading>
            <Flex flexDirection={["column", "row"]}>
              <FormElement name="phoneNumber" type="tel" state={formData} handleInputChange={handleInputChange}/>
              <FormElement name="email" type="email" state={formData} handleInputChange={handleInputChange}/>
            </Flex>
           </Box>
           {(state < 3) &&
            <Box textAlign="right" mt="6">
              <Button type="submit" aria-label={t('userform.Submit-user')} mt={["6"]} ml="4" onClick={() => submitForm()} disabled={formErrors} isLoading={loading} loadingText={t('userform.Submitting')}>
                {t('userform.Submit-user')}
              </Button>
            </Box>
           }
           {
            companyErrors && <MessageBox isOpen={true} type="error" errorObject={companyErrors}/>
           }
           {
            state === 3 && <MessageBox type="info" message={t('manualactivation.sent-info')} />
           }
        </Container>
      </>
      }
    </>
  );
}

export default ManualActivation;